import { Flex, Typography } from '@aloft/toolkit-sui';

import { FieldError, useFormContext } from 'react-hook-form';

export function AddressInputErrors() {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Flex flexDirection="column">
      {(Object.values(errors.address || {}) as FieldError[]).map(({ message }, index) => {
        if (message) {
          return (
            <Typography color="alertError" key={`error-${index}`}>
              {message}
            </Typography>
          );
        }
      })}
    </Flex>
  );
}
